export default __webpack_public_path__ + "static/media/Brasilcard.c55c8bbc.svg";